import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const vehiculosService = {
    getAllVehiculos,
    getVehiculoById,
    setStateVehiculoById,
    crudVehiculos,
    getClasesVehiculos,
    validateExistsDocument,
    getFilteredData
};

async function getAllVehiculos() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    let res = await fetch(`${url}/vehiculos/getAllVehiculos`, requestOptions)
    return res.json()
}

function getVehiculoById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/vehiculos/getVehiculoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudVehiculos(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/vehiculos/crudVehiculos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateVehiculoById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/vehiculos/setStateVehiculoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getClasesVehiculos() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/vehiculos/getClasesVehiculos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validateExistsDocument(document) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({document})
    };

    return fetch(`${url}/vehiculos/validateExistsDocument`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFilteredData(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/vehiculos/getFilteredData`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}




